import axios from "axios";
import StartTestApiInterface from "../Interfaces/StartTestApiInterface";
import NextTestApiInterface from "../Interfaces/NextTestApiInterface";

class TestApi {
  static data: Object;
  static status: Number;
  static sessionCode: string;
  static message: string;
  static totalQuestions: Number;
  static maxScore: Number;
  static categoryScores: Array<{ category_id: string; category_score: number }>;

  static async startTest(data: StartTestApiInterface) {
    await axios.post("https://edu.bot-n.ru/start/", data).then((response) => {
      this.data = response.data;
      this.status = response.status;
      this.sessionCode = response.data.session_code;
      this.totalQuestions = response.data.total_questions;
      this.maxScore = response.data.max_possible_score;
      this.message = response.data.message;
    });

    return {
      data: this.data,
      status: this.status,
      message: this.message,
      sessionCode: this.sessionCode,
      totalQuestions: this.totalQuestions,
      maxScore: this.maxScore,
    };
  }

  static async nextTest(data: NextTestApiInterface) {
    await axios.post("https://edu.bot-n.ru/answer/", data).then((response) => {
      this.data = response.data;
      this.status = response.status;
      this.message = response.data.message;
      this.categoryScores = response.data.category_scores;
    });

    return {
      data: this.data,
      status: this.status,
      message: this.message,
      scores: this.categoryScores,
    };
  }
}

export default TestApi;
